<nav class="container header-bg">
    <div class="nav-notificacoes-flex" *ngIf="isNotificacoesPage()">
        <div class="nav-notificacoes">
            <img src="assets/icons/home.svg" alt="">
            <p class="nav-indicator">Notificações</p>
        </div>
        <h1 class="nav-title-notification" >{{ servicesTitle }}</h1>
    </div>
    <div class="nav-generic" *ngIf="!isNotificacoesPage()" >
        <h1 class="nav-title">{{ servicesTitle }}</h1>
    </div>
</nav>